export const markupReqTemp = {
  "fareRuleType":"",
  "ruleName":"",
  "markType":"",
  "markUp": null
} 